import React from 'react';
import { useTranslation } from 'react-i18next';

import WarningIcon from '@/assets/images/icons/warning.svg';

import ErrorPage from '../ErrorPage';

const CriticalError = () => {
  const { t } = useTranslation();

  return (
    <ErrorPage
      logo={<WarningIcon />}
      title={t('components.CriticalError.title')}
      linkHref="/"
      linkText={t('components.CriticalError.linkText')}
    >
      {t('components.CriticalError.textRequest')}
    </ErrorPage>
  );
};

export default CriticalError;
